export const required = value => (value ? undefined : 'Required');

export const maxLength = max => value =>
  value && value.length > max ? `Must be ${max} characters or less` : undefined;

export const maxLength10 = maxLength(10);

export const mobile = value =>
  value && !/^04(\d{8})$/i.test(value.replace(/\s/g, '')) ?
    'Invalid mobile number' : undefined;

export const confirmPhoneNumber = (value, allValues) =>
  value.replace(/\s/g, '') !== allValues.phoneNumber.replace(/\s/g, '') ?
    "Mobile numbers do not match" : undefined;

export const poBox = (value) =>
  /(?:(?:R(?:oad)?[\.\-\s]*(?:(?:M(?:ail)?[\.\-\s]*)?B(?:ox|in|\b|\d)))|(?:P(?:ost(?:al)?)?[\.\-\s]*(?:(?:O(?:ffice)?[\.\-\s]*)?B(?:ox|in|\b|\d)|o(?:ffice|\b)(?:[-\s]*\d)|code))|box[-\s\b]*\d)/ig.test(value) ?
    "PO Boxes/RMB's are not allowed" : undefined;


// WEBPACK FOOTER //
// ./app/util/validations.js